export default class OutrightOutcomeModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Outcome ID
     * @type {number}
     */
    this.id = data.otoid;
    /**
     * Outright id
     * @type {number}
     */
    this.oid = data.outid;
    /**
     * Competitor id
     * @type {number}
     */
    this.competitorId = data.cmid;
    /**
     * IsPublished flag
     * @type {boolean}
     */
    this.isPublished = data.ispubl === 1;
    /**
     * Outcome Name
     * @type {string}
     */
    this.name = data.on;
    /**
     * Outcome value
     * @type {string}
     */
    this.outcome = data.o;
    /**
     * Outcome value in original format ready for parsing
     * @type {string}
     */
    this.originalDecimalOutcome = data.o;
    /**
     * Rank id
     * @type {number}
     */
    this.rank = data.rankid;
   /**
     *  outcome market type id 
     * @type {number}
     */
    this.outcomeId = data.oid;
  }
}
